import getAPIRoot from "services/api-root";
import axios, { AxiosPromise, Method, ResponseType } from "axios";
import qs from "qs";

axios.defaults.paramsSerializer = params => qs.stringify(params, { arrayFormat: "brackets" });

interface RequestOptions {
  method: Method;
  url: string;
  params?: Record<string, unknown>;
  data?: Record<string, unknown>;
  requestType?: string;
  responseType?: ResponseType;
}

class AdaAPI {
  requestTokens: {[key: string]: () => void};

  constructor() {
    this.requestTokens = {};
  }

  cancelLastRequest(requestType: string): void {
    const previousCancelToken = this.requestTokens[requestType];

    if (previousCancelToken) {
      previousCancelToken();
    }
  }

  /**
   * @param {Object} p
   * @param {String} p.method
   * @param {String} p.url
   * @param {Object} [p.params={}]
   * @param {Object} [p.data={}]
   * @param {String} [p.requestType=null]
   * @param {String} [p.responseType="json"]
   * @returns {Promise}
   */
  request({
    method,
    url,
    params = {},
    data = {},
    requestType = null,
    responseType = "json"
  }: RequestOptions): AxiosPromise<Record<string, unknown>> {
    const { CancelToken } = axios;

    return axios({
      method,
      url,
      withCredentials: true,
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json"
      },

      params,
      data,
      responseType,
      baseURL: getAPIRoot(),
      cancelToken: new CancelToken((cancel) => {
        if (requestType) {
          this.requestTokens[requestType] = cancel;
        }
      })
    });
  }
}

// Create new AdaAPI instance
export const adaAPI = new AdaAPI();

export const vimeoApi = axios.create({
  baseURL: "https://vimeo.com/api/oembed.json",
  headers: {
    "Content-Type": "application/json"
  }
});
